import { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import { getMissingDocuments, sendKYC } from '../../../../../store/company-information/actions';
import SectionDocs from './section-docs';
import Loading from '../../../../common/loading';
import { ItemOnboardingMenu } from '../../../onboarding-menu';
import AddBankAccountOnboarding from '../../../bank-accounts/add-bank-account-forms/add-bank-account-onboarding';

interface KYCLevel2State {
  companyInformation: {
    loading: boolean;
    error: boolean;
    errorInfo: object;
    missingDocuments: any;
  };
  dashboard: {
    merchantMe: {
      company: any;
      country: string;
    };
  };
}

interface KYCLevel2StateProps {
  loading: boolean;
  error: boolean;
  errorInfo: object;
  missingDocuments: any;
  isCompany: boolean;
  country: string;
}

interface KYCLevel2Dispatch {
  getMissingDocuments: () => void;
  sendData: (values: any) => void;
}

interface KYCLevel2Props extends KYCLevel2StateProps, KYCLevel2Dispatch {
  setOnboardingMenu: (menu: ItemOnboardingMenu[]) => void;
}

const KYCLevel2: FC<KYCLevel2Props> = ({
  loading,
  error,
  errorInfo,
  isCompany,
  missingDocuments,
  country,
  getMissingDocuments,
  sendData,
  setOnboardingMenu,
}): JSX.Element => {
  const [step, setStep] = useState(1);

  const [menuSectionOne, setMenuSectionOne] = useState<ItemOnboardingMenu[]>([]);
  const [menuSectionTwo, setMenuSectionTwo] = useState<ItemOnboardingMenu[]>([]);

  useEffect(() => {
    getMissingDocuments();
  }, []);

  useEffect(() => {
    // Skip step 1 if only document from step 2 is missing.
    if (missingDocuments && missingDocuments.length === 1 && missingDocuments.includes('bankAccountDocument')) {
      setStep(2);
    }
  }, [missingDocuments]);

  useEffect(() => {
    setOnboardingMenu(menuSectionOne.concat(menuSectionTwo));
  }, [menuSectionOne, menuSectionTwo]);

  return (
    <div className="kyc-level-2">
      {loading && <Loading fullScreem />}
      <div style={{ display: step === 1 ? 'block' : 'none' }}>
        <AddBankAccountOnboarding
          displayed={step === 1}
          onChangeMenu={(menu: ItemOnboardingMenu[]) => setMenuSectionOne(menu)}
          onClickNext={() => setStep(2)}
        />
      </div>
      <div style={{ display: step === 2 ? 'block' : 'none' }}>
        <SectionDocs
          error={error}
          errorInfo={errorInfo}
          displayed={step === 2}
          isCompany={isCompany}
          missingDocuments={missingDocuments}
          onClickNext={values => sendData({ ...values })}
          onChangeMenu={(menu: ItemOnboardingMenu[]) => setMenuSectionTwo(menu)}
          country={country}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: KYCLevel2State): KYCLevel2StateProps => ({
  loading: state.companyInformation.loading,
  error: state.companyInformation.error,
  errorInfo: state.companyInformation.errorInfo,
  missingDocuments: state.companyInformation.missingDocuments,
  isCompany: state.dashboard.merchantMe?.company,
  country: state.dashboard.merchantMe?.country,
});

const mapDispatchToProps = (dispatch: Function): KYCLevel2Dispatch => ({
  getMissingDocuments: () => dispatch(getMissingDocuments()),
  sendData: (values: any) => dispatch(sendKYC(values, 4)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KYCLevel2);
